var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promotionShow)?_c('div',{attrs:{"id":"promotion"}},[_c('div',{staticClass:"promotion-bg",on:{"click":_vm.close}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }